<eo-base-view [label]="label">
  <span [id]="id" [ngClass]="getClass()"> {{ getFormattedValue() }}</span>
</eo-base-view>
